import * as yup from 'yup';
import useTranslation from '../../../Hooks/useTranslation';
export default function usePatientManualRegistrationPolandFormValidationScheme(
	isChild: boolean,
) {
	const { t } = useTranslation();

	const validationSchema = yup.object({
		pesel: yup
			.string()
			.min(11, t('validation.patientManualRegistrationPolandForm.peselLength'))
			.max(11, t('validation.patientManualRegistrationPolandForm.peselLength'))
			.required(t('validation.patientManualRegistrationPolandForm.pesel')),
		salutationBefore: yup.string().notRequired(),
		salutationAfter: yup.string().notRequired(),
		firstName: yup
			.string()
			.required(t('validation.patientManualRegistrationCzechForm.firstName')),
		lastName: yup
			.string()
			.required(t('validation.patientManualRegistrationCzechForm.lastName')),
		address: yup.object().shape({
			street: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.street'),
				),
			descriptiveNumber: yup
				.string()
				.required(
					t(
						'validation.patientManualRegistrationCzechForm.address.descriptiveNumber',
					),
				),
			guideNumber: yup.string().notRequired(),
			city: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.city'),
				),
			postCode: yup
				.string()
				.required(
					t('validation.patientManualRegistrationCzechForm.address.postCode'),
				),
		}),
		healthInsuranceCompany: yup.mixed().notRequired(),
		citizenship: yup
			.mixed()
			.required(t('validation.patientManualRegistrationCzechForm.citizenship')),
		phoneNumber: yup.string().notRequired(),
		email: isChild
			? yup
					.string()
					.email(t('validation.patientManualRegistrationCzechForm.email'))
					.notRequired()
			: yup
					.string()
					.email(t('validation.patientManualRegistrationCzechForm.email'))
					.required(t('validation.patientManualRegistrationCzechForm.email')),
		healthPlanCode: yup.mixed().notRequired(),
		healthPlanWorkplaceMember: yup.mixed().notRequired(),
		legalRepresentative: isChild
			? yup.object().shape({
					firstName: yup
						.string()
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.firstName',
							),
						),
					lastName: yup
						.string()
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.lastName',
							),
						),
					email: yup
						.string()
						.email(t('validation.patientManualRegistrationCzechForm.email'))
						.required(
							t(
								'validation.patientManualRegistrationCzechForm.legalRepresentative.email',
							),
						),
					phoneNumber: yup.string().notRequired(),
			  })
			: yup.mixed().notRequired(),
		createdByType: yup
			.object({
				value: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.createdByType'),
					),
				label: yup.string(),
			})
			.required(),
		createdById: yup.mixed().when('createdByType.value', {
			is: 'USER',
			then: yup
				.mixed()
				.required(
					t('validation.patientManualRegistrationCzechForm.createdById'),
				),
			otherwise: yup.mixed(),
		}),
	});

	return { validationSchema };
}
